import { BaseService } from "./BaseService";
import api from "../Interceptors/Interceptor";
import { AxiosResponse } from "axios";
import ApiResponse from "../Models/ApiResponse";
import ReferenceModel from "../Models/ReferenceModel";

export interface IGenericSelectItemModel {
    uuid?: string;
    type: string;
    code: string;
    name: string;
    description?: string;
    customer?: ReferenceModel | undefined;
    sequence?: number;
    active?: boolean;
}

export class GenericSelectItemService extends BaseService<IGenericSelectItemModel, IGenericSelectItemModel> {

    public async fetchByType(type: string): Promise<any> {
        return await api.get("v1/generic-select-item/select-item/by-type", {
            params: { type }
        });
    }

    public async fetchByCode(code: string): Promise<any> {
        return await api.get("v1/generic-select-item/select-item/by-code", {
            params: { code }
        });
    }

    public async fetchDistinctTypes(): Promise<AxiosResponse<ApiResponse<string[]>>> {
        return await api.get("v1/generic-select-item/distinct-types");
    }

    protected modelUrl(): string {
        return "generic-select-item";
    }
}
